import Link from "next/link";
import { useRouter } from "next/router";
import React, { VFC } from "react";
import styled from "styled-components";
import ShortTextSupport from "~/components/atoms/ShortTextSupport";
import { Project } from "~/models/project";
import { pagesPath } from "faqSrc/lib/$path";

interface Props {
  project?: Project;
}

const RecruitmentButton: VFC<Props> = ({ project }) => {
  const router = useRouter();
  // hide recruitment button in recruitment page
  if (router.pathname === pagesPath.recruitment.game_writer.$url().pathname) {
    return <></>;
  }

  return (
    <RecruitmentButtonWrap>
      <Link href={pagesPath.recruitment.game_writer.$url()} passHref>
        <Button className="btn-gradient">
          <ShortTextSupport
            fullText={project?.headerQuestionText || "ライター募集"}
            shortText={"ライター募集"}
          />
        </Button>
      </Link>
    </RecruitmentButtonWrap>
  );
};

const RecruitmentButtonWrap = styled.div`
  width: 100%;
`;

const Button = styled.a`
  align-items: center;
  display: block;
  border-radius: 38px;
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  padding: 0 8px
  height: 38px;
  line-height: 38px;
  margin-right: 4px;
  text-align: center;
`;

export default RecruitmentButton;
